/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/basket': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="#272c33"><path pid="0" data-color="color-2" d="M13 10H3a1 1 0 00-1 1v4a1 1 0 001 1h10a1 1 0 001-1v-4a1 1 0 00-1-1z"/><path pid="1" d="M13.118 5L10.894.553a1 1 0 00-1.789.894L10.882 5H5.118l1.776-3.553A1 1 0 105.105.553L2.882 5H0v4h16V5h-2.882z"/></g>'
  }
})
